module.exports = __webpack_public_path__ + "img/bold-line.f046f3cf.svg";